import React from 'react';

import StyledMuiPhoneNumber from './PhoneInput.styles';
import { MuiPhoneNumberProps } from 'material-ui-phone-number';

const PhoneInput: React.FC<{
  value: string;
  name?: string;
  onChange: MuiPhoneNumberProps['onChange'];
  onBlur: MuiPhoneNumberProps['onBlur'];
  style?: MuiPhoneNumberProps['style']
  className?: string;
  fullWidth?: boolean;
  helperText?: string;
  error?: boolean;
}> = (props) => {
  const handleChange = (value: string) => {
    props.onChange({
      target: {
        value,
        name: props.name,
      }
    } as Parameters<MuiPhoneNumberProps['onChange']>[0])
  };

  return (
    <StyledMuiPhoneNumber
      defaultCountry="us"
      value={props.value}
      onChange={handleChange as MuiPhoneNumberProps['onChange']}
      onBlur={props.onBlur}
      name={props.name}
      variant="outlined"
      className={props.className}
      fullWidth={props.fullWidth ?? true}
      style={props.style}
      helperText={props.helperText}
      error={props.error}
    />
  );
};

export default PhoneInput;